/**
 * @Description: 用于存储系统中用来检索的标签关键词定义相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  TagsModel,
  TagsSearchModel,
  TagsPageSearchModel,
  TagsAddModel,
  TagsUpdateModel,
  IdsModel
} from '@/model/product/TagsModel'

const baseUrl = Route.product + '/tags'

/**
 * 搜索分页数据
 */
export const pageSearchTags = (param: TagsPageSearchModel) => {
  return https().request<RootObject<PageRespModel<TagsModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchTags = (param: TagsSearchModel) => {
  return https().request<RootObject<TagsModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getTags = (id: number) => {
  return https().request<RootObject<TagsModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 根据value查找数据
 */
export const getTagsByValue = (value: string) => {
  return https().request<RootObject<TagsModel>>(baseUrl.concat('/get/value/').concat(value), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addTags = (param: TagsAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateTags = (param: TagsUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeTags = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveTags = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
